"use client";

import { useState } from "react";
import { Box, styled } from "@mui/material";
import { Button, SplitButton } from "@/ui";
import toast from "react-hot-toast";
import AddToFloatDialog from "../modals/AddToFloatDialog";

const ActionsBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: theme.spacing(1),
}));

export default function CandidateActions({ candidate, onFloat, onSubmit, showSave = false, size = "small" }) {
  const [addToFloatOpen, setAddToFloatOpen] = useState(false);
  const who = candidate?.name?.trim().split(/\s+/)[0] || "candidate";
  const splitSize = size === "small" ? "sm" : "md";

  const handleSave = () => {
    toast.success(`${candidate?.name || "Candidate"} saved`);
  };

  return (
    <ActionsBox>
      {showSave && (
        <Button variant="secondary" size={splitSize} onClick={handleSave}>
          Save
        </Button>
      )}
      <SplitButton
        label={`Float ${who}`}
        variant="primary"
        size={splitSize}
        onClick={onFloat}
        items={[
          { label: "Create new float", onClick: onFloat },
          { label: "Add to existing float", onClick: () => setAddToFloatOpen(true) },
        ]}
      />
      <Button variant="primary" size={splitSize} onClick={onSubmit}>
        Submit {who}
      </Button>
      <AddToFloatDialog
        open={addToFloatOpen}
        onClose={() => setAddToFloatOpen(false)}
        candidate={candidate}
      />
    </ActionsBox>
  );
}
